<template>
  <v-list-item-content :class="!compact ? 'imitationpadding' : 'pa-0'">
    <v-list-item-subtitle v-if="!compact"
                          class="labeltext pl-3 pt-1"
                          v-text="noempty ? label + '*' : label" />
    <slot name="value">
      <v-list-item-title v-html="displayString"
                         class="valuetext"
                         :class="[
                          (compact ? ' pa-0' : ' pl-3 pb-1 pt-1'), 
                          (textcolor), 
                          (loading ? 'blurred' : '')
                         ]">
      </v-list-item-title>
    </slot>
  </v-list-item-content>
</template>


<script>
export default {
  name: "NormalModeTemplate",
  props: ["label", "value", "valuecolor", "valuetext", "noempty", "compact", "suffix", "loading", "searchterm"],

  data() {
    return {};
  },

  mounted() {},

  methods: {},

  computed: {
    isEmpty() {
      return this.value === null || this.value === undefined || this.value === "";
    },

    textcolor() {
      if (this.isEmpty) {
        return this.compact ? "disabled--text" : "transparent--text";
      } else {
        return this.valuecolor ? this.valuecolor + "--text" : "";
      }
    },

    text() {
      if (this.valuetext) {
        return this.valuetext + (this.suffix ? this.suffix : "");
      } else if (this.isEmpty) {
        return this.compact ? this.label + (this.suffix ? ' ' + this.suffix : "") : "N/A";
      } else {
        return this.value + (this.suffix ? this.suffix : "");
      }
    },

    displayString() {
      if (this.searchterm) {
        return this.searchhighlight(this.text, this.searchterm, true);
      } else {
        return this.text;
      }
    },
  },

  watch: {},
};
</script>

<style scoped>
.imitationpadding {
  padding-top: 3px !important;
  padding-bottom: 2px !important;
}
.labeltext {
  font-size: 12px !important;
  margin-bottom: 1px;
}
.valuetext {
  font-size: 13px !important;
  white-space: normal;
}
.smallli .valuetext {
  font-size: 13px !important;
}
</style>